const UTM_PARAMS = {
  utm_source: 'marketplace',
  utm_medium: 'web',
  utm_campaign: 'listyourproperty',
};

export { UTM_PARAMS };
